//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SocoHttpService } from '@soco/http';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DBTraceLogService } from '../../services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../../services/coolEmail/coolEmail.service';
import { AccountVerificationService } from '../../components/accountverification/account-verification.service';
import { AccountVerificationInput, AccountVerificationOutput, AccountDetails } from '../../components/accountverification/account-verification-entities';
import { AppCommonService } from '../../services/common/app-common.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DBTraceLog, LogType } from '../../services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../../services/common/app-common-entities';
import { AppBaseComponent } from '../base/app-base.component';

@Component({
    selector: 'account-verification',
    templateUrl: 'account-verification.component.html',
    styleUrls: ['account-verification.component.css'],
    providers: [DatePipe, DBTraceLogService, AppCommonService, AccountVerificationService]
})
export class AccountVerificationComponent extends AppBaseComponent implements OnInit {

    //#region Variables
    public ldc: string = '';   
    public orderNumber: string = '';
    public premiseNumber: string = '';   
    public urlCode: string;
    public errorInfo: any;    
    public orderType: string = '';
    public personID: string = '';    
    public appConfigurationDataList: Array<AppConfigurationData> = [];        
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';    
    public portalTypeID: number = 0;    
    public accountVerificationOutput: AccountVerificationOutput;
    public emailToList: string;

    public cisOrderType: string = '';
    public ldcFullName: string;
    public contactPhoneNo: string = '';
    public contactHours: string = '';
    public accountDetails: AccountDetails;
    public showSpinner: boolean = false;
    public isValidateAccountPerformed: boolean = false;
    public acntNumberFromURL: string = '';
    accntVerifyFormGroup: FormGroup;

    @Input() accountVerificationInput: AccountVerificationInput;
    @Output() accountVerificationOutputEvent = new EventEmitter<AccountVerificationOutput>();
    @Output() processErrorEvent = new EventEmitter();

    //#endregion

    constructor(public datepipe: DatePipe, public http: SocoHttpService,
        public dbTraceLogService: DBTraceLogService, public deviceService: DeviceDetectorService, public coolEmailService: CoolEmailService,
        private appCommonService: AppCommonService, public accountVerificationService: AccountVerificationService) {

        //Parent component initialization
        super(http, dbTraceLogService, coolEmailService, deviceService);

        this.accountDetails = new AccountDetails();
        this.accountVerificationOutput = new AccountVerificationOutput();
    };


    ngOnInit() {
        try {
            //Get accnt verification input from parent
            this.GetAccountVerificationInput();

            this.accntVerifyFormGroup = new FormGroup({                
                accountNumber: new FormControl('', [Validators.required]),
                zipCode: new FormControl('', [Validators.required])
            });

            //Patch the account number from url to input box
            if (this.acntNumberFromURL != '') {
                //Patch value if above property contains numbers only
                if (/^\d+$/.test(this.acntNumberFromURL)) {
                    this.accntVerifyFormGroup.patchValue({
                        accountNumber: this.getMaskedAccountNumber(this.acntNumberFromURL)
                    });
                }
            }
            
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading ngOnInit, Error: ' + e.message.substring(0, 500));
        }

    }      

    //#region Account Verification & Order Eligibility
    public get accountNumber(): any {
        if (this.acntNumberFromURL != '' && this.accntVerifyFormGroup.value.accountNumber.includes('*'))
            return this.acntNumberFromURL.trim();
        else
            return this.accntVerifyFormGroup.value.accountNumber;
    }

    public get zipCode(): any {
        return this.accntVerifyFormGroup.value.zipCode;
    }

    validateAccountAndOrderEligibility() {
        try {
            //console.log('AccountNo - ', this.accountNumber);
            //console.log('ZipCode - ', this.zipCode);

            this.accntVerifyFormGroup.markAllAsTouched();

            //set flag on button click
            this.isValidateAccountPerformed = true;

            if (this.accntVerifyFormGroup.valid) {
                //Invoke service call
                this.showSpinner = true;
                this.insertDBTraceLog(LogType.Info, `Account & Order eligibility initiated for LDC: ${this.ldc}, CISOrderType: ${this.cisOrderType}, Accnt No: ${this.accountNumber}, Zipcode: ${this.zipCode}`);
                this.VerifyAccountAndOrderEligibility();
            }

            //reset session expiry
            //this.sessionExpired = false; //Check
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while validating account and order eligibility, Error: ' + e.message.substring(0, 500));
        }
    }

    /* Check if Account is valid & order is eligible to Schedule*/
    VerifyAccountAndOrderEligibility() {
        try {
            this.accountVerificationService.verifyAccountAndOrderEligibity(this.ldc, this.cisOrderType, this.accountNumber, this.zipCode).subscribe(ApiResult => {

                if (ApiResult.data != null) {
                    //console.log('Verify Account Api Result: ', ApiResult.data);

                    if (ApiResult.statusCode === 200 || ApiResult.data.quality > 0) {
                        this.accountDetails.isValidAccount = ApiResult.data.isValidAccount;
                        this.accountDetails.isOrderEligibleToSchedule = ApiResult.data.isOrderEligibleToSchedule;
                        this.accountDetails.orderNumber = ApiResult.data.fieldActivityID;
                        this.accountDetails.premiseNumber = ApiResult.data.premisesNumber;
                        this.accountDetails.personID = ApiResult.data.personID;
                        this.accountDetails.ldc = ApiResult.data.ldc;
                        this.accountDetails.serviceCenter = ApiResult.data.serviceCenter;
                        this.accountDetails.billingAddress = ApiResult.data.billingAddress;
                        this.accountDetails.premisesAddress = this.getFormatedPremiseAddess(ApiResult.data.premisesAddress);
                        this.accountDetails.customerName = ApiResult.data.customerName;
                        this.accountDetails.emailAddress = ApiResult.data.emailAddress;
                        this.accountDetails.phoneNumber = ApiResult.data.phoneNumber;
                        this.accountDetails.premiseType = ApiResult.data.premiseType;
                        this.accountDetails.isKMIEligible = ApiResult.data.isKMIEligible;
                        this.accountDetails.marketerName = ApiResult.data.marketerName;
                        this.accountDetails.marketerPhoneNumber = (ApiResult.data.marketerPhoneNumber != '' && ApiResult.data.marketerPhoneNumber) ? this.formatPhoneNumber(ApiResult.data.marketerPhoneNumber) : '';

                        if (ApiResult.data.isValidAccount)
                            this.accountDetails.customerFirstName = this.getCustomerFirstName(ApiResult.data.premiseType, ApiResult.data.customerName);
                        else
                            this.accountDetails.customerFirstName = '';

                        //console.log('Account Details: ', this.accountDetails);

                        //Recapturing LDC once again in case searching account belongs to diff ldc
                        this.ldc = this.accountDetails.ldc;
                        //set contact phone after fetching ldc from above api call
                        this.setContactPhoneNoAndHours();
                        this.getLDCFullName();

                        if (this.accountDetails.isOrderEligibleToSchedule)
                            this.insertDBTraceLog(LogType.Info, 'Account & Order eligibility is completed successfully, Order is eligible to schedule');
                        else
                            this.insertDBTraceLog(LogType.Info, 'Account & Order eligibility is completed successfully, Order is NOT eligible to schedule');

                        ////Once API call is completed move to next screen
                        //stepper.next();

                        ////show logout button from second screen onwards
                        //this.showLogOut = true;

                        this.showSpinner = false;

                        //Prepare output object and emit to parent component.
                        this.EmitOutputToParent();
                    }
                    else {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while validating account & order eligibility, APIResult status is not 200');
                        this.processError();
                    }
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while validating account & order eligibility, APIResult is null');
                    this.processError();
                }

            }, ApiResult => {
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while validating account & order eligibility, APIResult is invalid');
                    this.processError();
                }
            });
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while verifying account& order eligibility, Error: ' + e.message.substring(0, 500));
        }
    }

    //#endregion
    // #region Helper Methods

    private formatPhoneNumber(phoneNumberString: string) {
        if (phoneNumberString.length == 10) {
            //reformat and return phone number
            return phoneNumberString.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
        }
        return phoneNumberString
    }
    private getFormatedPremiseAddess(premiseAddress: string): string {
        var formatedPremiseAdd: string = premiseAddress;

        if (premiseAddress != null && premiseAddress != '' && premiseAddress.indexOf(',') > 0)
            formatedPremiseAdd = premiseAddress.replace(/,/g, ' ');

        return formatedPremiseAdd;
    }

    private getCustomerFirstName(premiseType: string, customerName: string): string {
        var custFirstName: string = customerName;

        if (this.ldc != 'AGLC') {
            if ((premiseType.toUpperCase().startsWith('RESIDENTIAL') || premiseType.toUpperCase().startsWith('RS')) && customerName.indexOf(',') > 0) {
                custFirstName = customerName.split(',')[1].trim();
            }
        }

        //console.log('custFirstName: ', custFirstName);
        return custFirstName;
    }

    public setContactPhoneNoAndHours() {

        this.contactPhoneNo = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Phone Number'))
            .map(cv => cv.configurationValue)[0];

        this.contactHours = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Hours'))
            .map(cv => cv.configurationValue)[0];
    }

    private getLDCFullName() {
        if (this.ldc === 'NG' || this.ldc === 'IL')
            this.ldcFullName = 'Nicor Gas';
        else if (this.ldc === 'VNG')
            this.ldcFullName = 'Virginia Natural Gas';
        else if (this.ldc === 'CGC')
            this.ldcFullName = 'Chattanooga Gas';
        else if (this.ldc === 'AGLC')
            this.ldcFullName = 'Southern Company Gas';
    }

    private getMaskedAccountNumber(accountNumber: string): string {
        var res: string = '';

        if (accountNumber.length > 3) {
            res = accountNumber.slice(0, accountNumber.length - 3).replace(/[0-9]/g, '*');
            res = res + accountNumber.substr(accountNumber.length - 3);
        }

        return res;
    }
    
    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = this.portalTypeID; //From parent
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.urlCode;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }

    processError(): void {
        this.processErrorEvent.emit();
    }

    private GetAccountVerificationInput() {

        this.acntNumberFromURL = this.accountVerificationInput.acntNumberFromURL;
        this.cisOrderType = this.accountVerificationInput.cisOrderType;        
        this.emailToList = this.accountVerificationInput.emailToList;
        this.ldc = this.accountVerificationInput.ldc;
        this.logReferenceID = this.accountVerificationInput.logReferenceID;
        this.portalTypeID = this.accountVerificationInput.portalTypeID;
        this.contactHours = this.accountVerificationInput.contactHours;
        this.contactPhoneNo = this.accountVerificationInput.contactPhoneNo;
    }

    private EmitOutputToParent() {
       
        this.accountVerificationOutput.accountDetails = this.accountDetails;
        this.accountVerificationOutput.accountNumber = this.accountNumber;

        this.accountVerificationOutputEvent.emit(this.accountVerificationOutput);
    }   

    // #endregion

}

